<template>
    <header class="header">
        <div class="navbar-fixed">
            <nav class="header-supploer-guest-desktop">
                <div class="container">
                    <a
                        @click="$emit('push-route', { url: 'CompetitionDashboardGuest', solo: false })"
                        class="brand-logo-supplier-guest-desktop"
                    >
                        <img src="@/assets/images/engelink_logo.svg" alt="Engelink" />
                    </a>
                    <ul class="supplier-guest-menu-top-desktop">
                        <li
                            @click="$emit('push-route', { url: 'CompetitionDashboardGuest', solo: false })"
                            :class="[{ 'active-link': $route.name === 'CompetitionDashboardGuest' }]"
                        >
                            <span class="supplier-guest-title-menu">Painel de cotações</span>
                        </li>
                        <li
                            @click="$emit('push-route', { url: 'EngelinkCredito', solo: false })"
                        >
                            <span class="supplier-guest-title-menu">Crédito</span>
                        </li>
                        <li
                            @click="$emit('push-route', { url: 'https://condo.news/', solo: true })"
                        >
                            <span class="supplier-guest-title-menu">CondoNews</span>
                        </li>
                        <li
                            @click="$emit('push-route', { url: 'https://pages.engelink.com.br/materiais', solo: true })"
                        >
                            <span class="supplier-guest-title-menu">Materiais</span>
                        </li>
                        <li
                            @click="$emit('push-route', { url: 'ContactUs', solo: false })"
                            :class="[{ 'active-link': $route.name === 'ContactUs' }]"
                        >
                            <span class="supplier-guest-title-menu">Fale conosco</span>
                        </li>
                        <li>
                            <span class="supplier-guest-title-menu" @click="$emit('openSubscriptionAlertModal')"
                                >Planos para fornecedores</span
                            >
                        </li>
                        <div>
                            <a
                                class="waves-effect waves-light btn btn-signup-suppler-guest"
                                @click="$emit('push-route', { url: 'Login', solo: false })"
                                >Entrar</a
                            >
                            <a
                                class="waves-effect waves-light btn btn-signup-suppler-guest-signup"
                                @click="$emit('push-route', { url: 'Signup', solo: false })"
                                >Cadastre-se</a
                            >
                        </div>
                    </ul>
                </div>
            </nav>
        </div>
    </header>
</template>

<script>
export default {
    name: 'HeaderSupplierGuestDesktop'
};
</script>

<style>
.header {
    height: 53px;
}

.header-supploer-guest-desktop {
    background-color: #ffffff;
    z-index: 999 !important;
    height: 53px;
    line-height: 53px;
    box-shadow: 0px 3px 6px #00000029;
}

.header-supploer-guest-desktop .container {
    width: 90% !important;
    display: flex;
    justify-content: center;
    justify-items: space-between;
}

.brand-logo-supplier-guest-desktop {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    cursor: pointer;
}
.supplier-guest-menu-top-desktop {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
    /* padding-inline: 30px; */
}
.supplier-guest-menu-top-desktop li {
    display: inline-block;
    position: relative;
    cursor: pointer;
    font-size: 16px;
    color: #707070;
    /* margin-left: 30px; */
}

.supplier-guest-menu-top-desktop li.active-link {
    background-color: none;
    color: #000;
}

.supplier-guest-menu-top-desktop li .supplier-guest-title-menu {
    padding-inline: 10px;
}
.supplier-guest-menu-top-desktop li:hover {
    transition: 0.3s;
    color: #000;
}
.supplier-guest-menu-top-desktop li.active-link:after {
    content: '';
    position: relative;
    bottom: 3px;
    display: block;
    margin: auto;
    height: 4px;
    width: 0px;
    background: transparent;
    transition: width 0.3s ease, background-color 0.3s ease;
}
.supplier-guest-menu-top-desktop li.active-link:after {
    width: 100%;
    background: #000;
}
.btn-signup-suppler-guest {
    color: #007bff;
    background-color: #fff;
    border: solid 1px #007bff;
    box-shadow: none !important;
    text-transform: none;
    margin-right: 17px !important;
    font-size: 16px !important;
    font-weight: 600;
    height: 40px;
    border-radius: 3px;
    padding: 10px;
    line-height: 18px;
}
.btn-signup-suppler-guest:hover {
    color: #007bff;
    background-color: #fff;
}
.btn-signup-suppler-guest-signup {
    box-shadow: none !important;
    color: #fff;
    background-color: #007bff;
    border: solid 1px #007bff;
    text-transform: none;
    margin-left: 0px !important;
    margin-right: 0px !important;
    font-size: 16px !important;
    font-weight: 600;
    height: 40px;
    padding: 10px;
    border-radius: 3px;
    line-height: 18px;
}
.btn-signup-suppler-guest-signup:hover {
    color: #007bff;
    background-color: #fff;
}
</style>
